module.exports = __webpack_public_path__ + "assets/f7f00c0fa2817fab1baa04644684b177.mp3";